const formatters = new Map<string, Intl.DateTimeFormat>();

// A UTC-shaped timestamp representing the wall-clock fields in a timezone.
export function wallTime(instant: number, timezone: string): number {
  let formatter = formatters.get(timezone);
  if (!formatter) {
    formatter = new Intl.DateTimeFormat("en-US", { timeZone: timezone, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" });
    formatters.set(timezone, formatter);
  }
  const parts = Object.fromEntries(formatter.formatToParts(instant).map(part => [part.type, part.value]));
  return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute));
}

export function wallToInstant(wall: number, timezone: string): number {
  // Sample both sides of a DST transition. Prefer the earlier occurrence of a
  // repeated time; shift nonexistent spring-forward times forward by the gap.
  const offsets = [-86400000, 0, 86400000].map(delta => wallTime(wall + delta, timezone) - (wall + delta));
  const candidates = [...new Set(offsets)].map(offset => wall - offset).sort((a, b) => a - b);
  return candidates.find(instant => wallTime(instant, timezone) === wall)
    ?? candidates.filter(instant => wallTime(instant, timezone) > wall).sort((a, b) => wallTime(a, timezone) - wallTime(b, timezone))[0]!;
}
